import { Injectable } from '@angular/core';
import {
  Router,
  NavigationExtras,
  UrlTree,
  UrlCreationOptions,
  Navigation,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CustomRouter {
  constructor(private router: Router) {}

  navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    extras = this.buildNavigationExtras(commands, extras);
    return this.router.navigate(commands, extras);
  }

  createUrlTree(
    commands: any[],
    navigationExtras?: UrlCreationOptions
  ): UrlTree {
    navigationExtras = this.buildNavigationExtras(commands, navigationExtras);
    return this.router.createUrlTree(commands, navigationExtras);
  }

  lastSuccessfulNavigation(): Navigation | null {
    return this.router.lastSuccessfulNavigation;
  }

  getCurrentNavigation(): Navigation | null {
    return this.router.getCurrentNavigation();
  }

  private buildNavigationExtras(
    commands: any[],
    navigationExtras?: NavigationExtras | UrlCreationOptions
  ): NavigationExtras | UrlCreationOptions | undefined {
    const destinationUrl = this.router.createUrlTree(commands).toString();
    const isLoginOrRegistrationFlow =
      destinationUrl === '/' || 
      destinationUrl.startsWith('/social') ||
      destinationUrl.startsWith('/registration');

    if (isLoginOrRegistrationFlow) {
      const provider = this.router.routerState.snapshot.root.queryParams['provider'];
      if (provider) {
        navigationExtras = {
          ...navigationExtras,
          queryParams: { ...navigationExtras?.queryParams, provider: provider },
        };
      }
    }

    return navigationExtras;
  }
}
